import { AddressWithId } from '../services/addressService';

/**
 * Function to select an address from a list - chooses default address first, then first valid address
 */
export const selectBestAddressFrom = (addressList: AddressWithId[]) => {
  if (!addressList || addressList.length === 0) {
    return null;
  }
  
  // Make sure we only work with valid addresses that have IDs
  const validAddresses = addressList.filter(addr => addr && addr.id);
  if (validAddresses.length === 0) {
    return null;
  }
  
  // Find default address first
  const defaultAddress = validAddresses.find(addr => addr.isDefault);
  
  if (defaultAddress) {
    return defaultAddress;
  }
  
  // If no default, return the first valid address
  return validAddresses[0];
}; 